import React from 'react'
import "./index.scss"
const Project = () => {
  return (
    <div>
         <div className="container project-page">
 <div className="text-zone">
 <h1>Projects</h1>
 <div className="list">
<div className="pro">
<a target="_blank" rel="noreferrer" href=" https://weather-app-omega-teal.vercel.app/ " >

    <h2 > Weather App</h2>
    </a>
    </div>   
    <div className="pro">
    <a target="_blank" rel="noreferrer" href="https://news-app-gamma-ten.vercel.app/" >

     <h2>News App(Next.js) </h2>
     </a>
    </div>   
    <div className="pro">
    <a target="_blank" rel="noreferrer" href=" https://book-my-show-clone-orcin.vercel.app/ " >

    <h2> BookmyShow Clone</h2>
    </a>
    </div>   
    <div className="pro">
    <a target="_blank" rel="noreferrer" href="https://restraunt-website.vercel.app/ " >

    <h2>Restraunt website</h2>
    </a>
    </div>   
    <div className="pro">
    <a target="_blank" rel="noreferrer" href=" https://zomato-webpage.vercel.app/ " >

    <h2> Zomato Page</h2>
    </a>
    </div>   

 </div>
 
 </div>
  
</div>
    </div>
  )
}

export default Project